/** ALL ROUTES ARE DEFINE HERE */
export default [
  { path: "/", redirect: "/login" },
  {
    path: "/",
    component: () => import("../layouts/default.vue"),
    children: [
      /** DASHBOARD ADVANCE */
      {
        path: "dashboard/advance",
        name: "dashboard.advance",
        component: () => import("../views/dashboard/index.vue"),
        meta: {
          auth: true,
          permissions: "Advance Dashboard",
        },
      },
      /** DASHBOARD PRIVATE */
      {
        path: "dashboard/private",
        name: "dashboard.private",
        component: () => import("../views/private-dashboard/index.vue"),
        meta: {
          auth: true,
          permissions: "Dashboard",
        },
      },
      /** USERS */
      {
        path: "users",
        name: "users",
        component: () => import("../views/users/Index.vue"),
        meta: {
          auth: true,
          permissions: "User List",
        },
      },
      /** ROLES */
      {
        path: "roles",
        name: "roles",
        component: () => import("../views/roles/Index.vue"),
        meta: {
          auth: true,
          permissions: "Role List",
        },
      },
      /** SETTINGS */
      {
        path: "settings/company",
        name: "settings.company",
        component: () => import("../views/settings/company/Index.vue"),
        meta: {
          auth: true,
          permissions: "Settings",
        },
      },
      /** EDIT PROFILE */
      {
        path: "profile/edit",
        name: "edit_profile",
        component: () => import("../views/profile/Index.vue"),
        meta: {
          auth: true,
          permissions: "Dashboard",
        },
      },
      /** LEAD STATUES */
      {
        path: "lead-status",
        name: "lead.status",
        component: () => import("../views/setup/lead-status/Index.vue"),
        meta: {
          auth: true,
          permissions: "Lead Status List",
        },
      },
      /** TEAMS */
      {
        path: "teams",
        name: "teams",
        component: () => import("../views/setup/teams/Index.vue"),
        meta: {
          auth: true,
          permissions: "Teams List",
        },
      },
      /** LEAD SOURCES */
      {
        path: "lead-sources",
        name: "lead.sources",
        component: () => import("../views/leads/sources/Index.vue"),
        meta: {
          auth: true,
          permissions: "Lead Source List",
        },
      },
      /** LEADS */
      {
        path: "leads",
        name: "leads",
        component: () => import("../views/leads/Index.vue"),
        meta: {
          auth: true,
          permissions: "Lead List",
        },
      },
      /** LEAD REPORT */
      {
        path: "reports/leads",
        name: "reports.leads",
        component: () => import("../views/reports/leads/Index.vue"),
        meta: {
          auth: true,
          permissions: "Lead Report",
        },
      },
      /** LEAD TRANSFARRED */
      {
        path: "leads/transfer",
        name: "leads.transfer",
        component: () => import("../views/leads/transferred/Index.vue"),
        meta: {
          auth: true,
          permissions: "Lead Transfer",
        },
      },
      /** LOST TO REOPEN */
      {
        path: "leads/lost-to-reopen",
        name: "leads.bulk-reopen",
        component: () => import("../views/leads/lost-to-reopen/Index.vue"),
        meta: {
          auth: true,
          permissions: "Lead Reopen",
        },
      },
    ],
  },
  /** LOGIN & FALLBACK */
  {
    path: "/",
    component: () => import("../layouts/blank.vue"),
    children: [
      {
        path: "login",
        name: "login",
        component: () => import("../views/auth/login.vue"),
        meta: {
          auth: false,
        },
      },
      {
        path: "forbidden",
        name: "forbidden",
        component: () => import("../views/error/403.vue"),
        meta: {
          forbidden: true,
        },
      },
      {
        path: "/:pathMatch(.*)*",
        component: () => import("../views/error/404.vue"),
        meta: {
          fallback: true,
        },
      },
    ],
  },
];
